/* LIVVRA Ayurvedic Theme — Main JavaScript */
/* Brand: Livvra India | livvraindia.com */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================
  // 1. HEADER SCROLL EFFECT
  // ============================================
  const header = document.getElementById('siteHeader');
  window.addEventListener('scroll', function () {
    if (window.scrollY > 50) {
      header && header.classList.add('scrolled');
    } else {
      header && header.classList.remove('scrolled');
    }
  });

  // ============================================
  // 2. HERO SLIDER
  // ============================================
  const heroSlides = document.querySelectorAll('.hero-slide');
  const heroDots = document.querySelectorAll('.hero-dot');
  let heroCurrentSlide = 0;
  let heroAutoPlay;

  function goToSlide(index) {
    heroSlides[heroCurrentSlide] && heroSlides[heroCurrentSlide].classList.remove('active');
    heroDots[heroCurrentSlide] && heroDots[heroCurrentSlide].classList.remove('active');
    heroCurrentSlide = (index + heroSlides.length) % heroSlides.length;
    if (heroSlides[heroCurrentSlide]) {
      heroSlides[heroCurrentSlide].classList.add('active');
      heroSlides[heroCurrentSlide].classList.add('slide-enter');
      setTimeout(() => heroSlides[heroCurrentSlide].classList.remove('slide-enter'), 700);
    }
    heroDots[heroCurrentSlide] && heroDots[heroCurrentSlide].classList.add('active');
  }

  const heroPrev = document.getElementById('heroPrev');
  const heroNext = document.getElementById('heroNext');
  if (heroPrev) heroPrev.addEventListener('click', () => { goToSlide(heroCurrentSlide - 1); resetAutoPlay(); });
  if (heroNext) heroNext.addEventListener('click', () => { goToSlide(heroCurrentSlide + 1); resetAutoPlay(); });

  heroDots.forEach((dot, idx) => {
    dot.addEventListener('click', () => { goToSlide(idx); resetAutoPlay(); });
  });

  function startAutoPlay() {
    heroAutoPlay = setInterval(() => goToSlide(heroCurrentSlide + 1), 5000);
  }
  function resetAutoPlay() { clearInterval(heroAutoPlay); startAutoPlay(); }
  if (heroSlides.length > 1) startAutoPlay();

  // ============================================
  // 3. SCROLL-TRIGGERED ANIMATIONS
  // ============================================
  const animateElements = document.querySelectorAll('[data-animate]');
  const staggerContainers = document.querySelectorAll('.stagger-children');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-delay') || '0';
        setTimeout(() => {
          entry.target.classList.add('animated');
        }, parseInt(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  animateElements.forEach(el => observer.observe(el));

  const staggerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        staggerObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  staggerContainers.forEach(el => staggerObserver.observe(el));

  // ============================================
  // 4. PRODUCT FILTER TABS (Homepage)
  // ============================================
  const filterTabs = document.querySelectorAll('.filter-tab');
  const productGrid = document.getElementById('productsGrid');

  filterTabs.forEach(tab => {
    tab.addEventListener('click', function () {
      filterTabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      if (productGrid) {
        const filter = this.getAttribute('data-filter');
        const cards = productGrid.querySelectorAll('.product-card');
        cards.forEach(card => {
          const category = card.getAttribute('data-category');
          if (filter === 'all' || category === filter) {
            card.classList.remove('hidden');
            card.style.animation = 'fadeInUp 0.4s ease forwards';
          } else {
            card.classList.add('hidden');
          }
        });
      }
    });
  });

  // ============================================
  // 5. FAQ ACCORDION
  // ============================================
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const btn = item.querySelector('.faq-question');
    if (btn) {
      btn.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        faqItems.forEach(i => i.classList.remove('active'));
        if (!isActive) item.classList.add('active');
      });
    }
  });

  // ============================================
  // 6. REVIEWS SLIDER
  // ============================================
  const reviewsSlider = document.getElementById('reviewsSlider');
  const reviewsPrev = document.getElementById('reviewsPrev');
  const reviewsNext = document.getElementById('reviewsNext');

  if (reviewsSlider && reviewsPrev && reviewsNext) {
    const scrollReviews = (dir) => {
      const cardWidth = reviewsSlider.querySelector('.review-card')?.offsetWidth + 24 || 360;
      reviewsSlider.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
    };
    reviewsPrev.addEventListener('click', () => scrollReviews(-1));
    reviewsNext.addEventListener('click', () => scrollReviews(1));
  }

  // ============================================
  // 7. MOBILE MENU
  // ============================================
  const menuToggle = document.getElementById('mobileMenuToggle');
  const mobileMenu = document.getElementById('mobileMenu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
      this.classList.toggle('open');
      // Animate hamburger
      const spans = this.querySelectorAll('span');
      if (this.classList.contains('open')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
      }
    });
  }

  // Mobile submenu
  document.querySelectorAll('.mobile-sub-toggle').forEach(toggle => {
    toggle.addEventListener('click', function () {
      const subList = this.nextElementSibling;
      subList && subList.classList.toggle('open');
      this.textContent = subList && subList.classList.contains('open')
        ? this.textContent.replace('▾', '▴')
        : this.textContent.replace('▴', '▾');
    });
  });

  // ============================================
  // 8. SEARCH OVERLAY
  // ============================================
  const searchToggle = document.querySelector('.search-toggle');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchClose = document.getElementById('searchClose');
  const searchInput = document.getElementById('searchInput');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('open');
      setTimeout(() => searchInput && searchInput.focus(), 300);
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', () => searchOverlay.classList.remove('open'));
  }
  searchOverlay && searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) searchOverlay.classList.remove('open');
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') searchOverlay && searchOverlay.classList.remove('open');
  });

  // ============================================
  // 9. BACK TO TOP
  // ============================================
  const backToTop = document.getElementById('backToTop');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('visible', window.scrollY > 400);
    });
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ============================================
  // 10. COUNTER ANIMATION
  // ============================================
  const counters = document.querySelectorAll('[data-count]');
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const target = parseInt(el.getAttribute('data-count'));
        let current = 0;
        const increment = target / 60;
        const timer = setInterval(() => {
          current += increment;
          if (current >= target) { current = target; clearInterval(timer); }
          el.textContent = Math.floor(current).toLocaleString('en-IN') + '+';
        }, 16);
        counterObserver.unobserve(el);
      }
    });
  }, { threshold: 0.5 });
  counters.forEach(el => counterObserver.observe(el));

  // ============================================
  // 11. COLLECTION VIEW TOGGLE
  // ============================================
  const viewBtns = document.querySelectorAll('.view-btn');
  const collectionGrid = document.getElementById('collectionGrid');
  viewBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      viewBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      if (collectionGrid) {
        const view = this.getAttribute('data-view');
        collectionGrid.className = 'products-grid ' + (view === 'grid4' ? 'grid-3' : 'grid-2');
      }
    });
  });

  // ============================================
  // 12. STICKY ADD TO CART (Product Page)
  // ============================================
  const addCartBtn = document.querySelector('.product-add-cart');
  if (addCartBtn) {
    const stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-add-bar';
    stickyBar.innerHTML = `
      <div class="container">
        <div class="sticky-bar-inner">
          <div class="sticky-product-info">
            <strong class="sticky-title">${document.querySelector('.product-title')?.textContent || ''}</strong>
            <span class="sticky-price">${document.querySelector('.prod-price-current')?.textContent || ''}</span>
          </div>
          <button class="btn btn-primary btn-lg sticky-btn" onclick="document.querySelector('.product-add-buttons').scrollIntoView({behavior:'smooth'})">
            🛒 Add to Cart
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(stickyBar);

    const addBtnObserver = new IntersectionObserver((entries) => {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });

    const addBtnsSection = document.querySelector('.product-add-buttons');
    if (addBtnsSection) addBtnObserver.observe(addBtnsSection);
  }

  // ============================================
  // 13. SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ============================================
  // 14. MOBILE SIDEBAR CLOSE ON OUTSIDE CLICK
  // ============================================
  const sidebar = document.getElementById('collectionSidebar');
  if (sidebar) {
    document.addEventListener('click', (e) => {
      if (sidebar.classList.contains('open') && !sidebar.contains(e.target) && !e.target.closest('.mobile-filter-toggle')) {
        sidebar.classList.remove('open');
      }
    });
  }

  // ============================================
  // 15. LAZY LOAD IMAGES
  // ============================================
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imgObserver.unobserve(img);
        }
      });
    });
    lazyImages.forEach(img => imgObserver.observe(img));
  }

  // ============================================
  // 16. NEWSLETTER FORM
  // ============================================
  const newsletterForm = document.getElementById('ContactFooter');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      const emailInput = this.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        const btn = this.querySelector('.nl-btn');
        if (btn) {
          btn.textContent = '✓ Subscribed!';
          btn.style.background = '#25D366';
          setTimeout(() => { btn.textContent = 'Subscribe →'; btn.style.background = ''; }, 3000);
        }
      }
    });
  }

  // ============================================
  // 17. STICKY ADD TO CART STYLES
  // ============================================
  const stickyStyles = document.createElement('style');
  stickyStyles.textContent = `
    .sticky-add-bar {
      position: fixed;
      bottom: -80px;
      left: 0;
      right: 0;
      background: #fff;
      box-shadow: 0 -4px 20px rgba(0,0,0,0.12);
      padding: 12px 0;
      z-index: 998;
      transition: bottom 0.3s ease;
    }
    .sticky-add-bar.visible { bottom: 0; }
    .sticky-bar-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
    }
    .sticky-title {
      font-family: 'Poppins', sans-serif;
      font-size: 14px;
      font-weight: 700;
      color: var(--text-primary);
      display: block;
      margin-bottom: 2px;
    }
    .sticky-price {
      font-family: 'Poppins', sans-serif;
      font-size: 18px;
      font-weight: 700;
      color: var(--green-dark);
    }
    @media (max-width: 600px) { .sticky-product-info { display: none; } }
  `;
  document.head.appendChild(stickyStyles);

  console.log('✅ LIVVRA Theme v1.0 Loaded | livvraindia.com');
});

// ============================================
// PAGE-SPECIFIC: PRODUCT ADD TO CART (AJAX)
// ============================================
function addToCartAjax(variantId, quantity = 1) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(res => res.json())
  .then(data => {
    showNotification('✓ Added to cart! ' + data.title, 'success');
    updateCartCount();
  })
  .catch(() => showNotification('Error adding to cart. Please try again.', 'error'));
}

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const countEl = document.querySelector('.cart-count');
      if (countEl) countEl.textContent = cart.item_count;
    });
}

function showNotification(msg, type = 'success') {
  const notification = document.createElement('div');
  notification.className = 'livvra-notification ' + type;
  notification.textContent = msg;
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${type === 'success' ? '#0D4A2D' : '#e63946'};
    color: #fff;
    padding: 14px 24px;
    border-radius: 12px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    z-index: 99999;
    box-shadow: 0 8px 30px rgba(0,0,0,0.2);
    animation: slideInRight 0.4s ease;
    max-width: 320px;
  `;
  document.body.appendChild(notification);
  setTimeout(() => {
    notification.style.animation = 'slideOutRight 0.4s ease forwards';
    setTimeout(() => notification.remove(), 400);
  }, 3000);
}

// Add notification animations
const notifStyles = document.createElement('style');
notifStyles.textContent = `
  @keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
  @keyframes slideOutRight { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0; } }
  @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
`;
document.head.appendChild(notifStyles);
